import {
    FETCHED_ITEMS,
    FETCHING_ITEMS, SET_GRID_FILTER,
    SET_ITEMS_GRID_CURRENT_PAGE,
    SET_ITEMS_GRID_FILTER_CRITERIA,
    SET_ITEMS_GRID_PER_PAGE_RECORDS,
    SET_ITEMS_GRID_SORT_CRITERIA,
    UNSET_GRID_FILTER,
} from './types';

export function setGridFilter(filterId, value, gridId) {
    return {
        type: SET_GRID_FILTER,
        payload: {
            filterId,
            value,
            gridId
        }
    }
}

export function unsetGridFilter(filterId, value, gridId) {
    return {
        type: UNSET_GRID_FILTER,
        payload: {
            filterId,
            value,
            gridId
        }
    }
}

export function fetchingItems(gridId) {
    return {
        type: FETCHING_ITEMS,
        payload: {
            gridId,
            loading: true
        }
    }
}

export function fetchedItems(gridId, data, totalPages) {
    return {
        type: FETCHED_ITEMS,
        payload: {
            gridId,
            data,
            totalPages
        }
    }
}

export function setItemsGridCurrentPage(gridId, currentPage) {
    return {
        type: SET_ITEMS_GRID_CURRENT_PAGE,
        payload: {
            gridId,
            currentPage
        }
    }
}

export function setItemsGridRecordsPerPage(gridId, perPage) {
    return {
        type: SET_ITEMS_GRID_PER_PAGE_RECORDS,
        payload: {
            gridId,
            perPage
        }
    }
}

export function setItemsGridSortCriteria(gridId, sorted) {
    return {
        type: SET_ITEMS_GRID_SORT_CRITERIA,
        payload: {
            gridId,
            sorted
        }
    }
}

export function setItemsGridFilterCriteria(gridId, filtered) {
    return {
        type: SET_ITEMS_GRID_FILTER_CRITERIA,
        payload: {
            gridId,
            filtered
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/grid/actions.js